/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Sixense */
import { BydModel } from '@sixense/byd-core-service';
/** Models */
import { DsMap } from '../../ds-maps/models/ds-map.class';
/** Interfaces */
import { DsMapInterface } from '../../ds-maps/interfaces/ds-map.interface';

@Injectable({
  providedIn: 'root',
})
export class DsLinearWorkMapsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get selected work maps using pagination.
   *
   * @param projectId Project ID
   * @param elementsPerPage Elements per page
   * @param pageIndex Page index
   * @returns Observable type `<BydModel<DsLinearLane[]>>`
   */
  public getMaps(projectId: number, elementsPerPage = 10, pageIndex = 0): Observable<BydModel<DsMap>> {
    this.path = `/v1/projects/${projectId}/works/plans`;
    const headers = this.bydRhsHeadersService.setHeadersWithPagination(elementsPerPage, pageIndex);
    return this.getModels<DsMap>({ headers });
  }

  /**
   * Get the map linked to the selected work.
   *
   * @param projectId Project ID
   * @param workId Work id
   * @returns Observable<DsMap>
   */
  public getWorkMap(projectId: number, workId: number): Observable<DsMap> {
    this.path = `/v1/projects/${projectId}/works/${workId}/plan`;
    return this.getModel<DsMap>();
  }

  /**
   * Create DsMap instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsMap` instance.
   */
  public createNewInstance(jsonObject: DsMapInterface): DsMap {
    return new DsMap(jsonObject);
  }
}
